import { AlertClasses, Theme } from "@mui/material";
import { OverridesStyleRules } from "@mui/material/styles/overrides";
import { InternalThemeConfig } from "../../config";

const alert = (
  config: InternalThemeConfig
): Partial<OverridesStyleRules<keyof AlertClasses, "MuiAlert", Theme>> => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "1.6rem",
    borderRadius: "8px",
    margin: 0,
    color: config.palette.textPrimary,
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
  },
  icon: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  message: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  action: {
    marginRight: 0,
    marginBottom: 2,
  },
  filledSuccess: {
    background: config.palette.success,
  },
  filledWarning: {
    background: config.palette.warning,
  },
  filledError: {
    background: config.palette.dangerLight,
  },
});

export default alert;
